
import '../style/components.css';
export function Navbar() {
    const toggleNav = () => {
        var nav = document.getElementById("navbar");
        nav.classList.toggle("responsive");
    }

    return (
        <header>
            <div className="navholder">
                <span className="logo">Kenzie's Corner</span>
                <nav className="navbar header" id="navbar">
                    <a href="./">About</a>
                    <a href="./projects">Projects</a>
                    <a href="./courses">Courses</a>
                    <a href="https://linkedin.com/in/macaligon">LinkedIn</a>
                    <button id="menu-icon" className="menu-icon" onClick={toggleNav}>
                        <img src='purple_burger.png' alt="Navbar" />
                    </button>
                </nav>
                {/* <span className='header'>Simplify</span>
            <label className="toggle">
                <input type="checkbox" id="simple-toggle" />
                    <span className="slider"></span>
            </label> */}
            </div>
        </header>
    );
}